import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import { omit, pick } from 'lodash-es';
import toast from 'react-hot-toast';
import { Icon, LoadingIcon } from '../Icon';
import styles from './index.module.less';
const IconMap = {
    success: _jsx(Icon, { type: "success" }),
    error: _jsx(Icon, { type: "risk" }),
    warning: null,
};
export const ToastContent = ({ title, message, processing, variant, onDismiss, }) => {
    const variantIcon = processing ? _jsx(LoadingIcon, {}) : variant ? IconMap[variant] : null;
    return (_jsxs("div", { className: classnames(styles.content, variant ? styles[variant] : null), children: [variantIcon && _jsx("div", { className: styles.icon, children: variantIcon }), _jsxs("div", { className: styles.texts, children: [_jsx("h2", { className: styles.title, children: title }), message && _jsx("p", { className: styles.message, children: message })] }), _jsx(Icon, { type: "close", className: styles.closeButton, onClick: onDismiss })] }));
};
const ariaProps = {
    className: styles.toastAriaContainerFix,
};
export function showToast(options) {
    const contentOptions = pick(options, 'title', 'message', 'processing', 'variant');
    const restOptions = omit(options, 'title', 'message', 'processing', 'variant');
    const toastId = toast((t) => {
        return (_jsx(ToastContent, { ...contentOptions, onDismiss: () => {
                toast.dismiss(t.id);
            } }));
    }, {
        /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
        // @ts-ignore
        ariaProps,
        duration: options.processing ? Infinity : undefined,
        ...restOptions,
    });
    return () => {
        toast.dismiss(toastId);
    };
}
